// removed by extract-text-webpack-plugin
module.exports = {"voyager-logo":"header__voyager-logo___3IWEF","right-controls":"header__right-controls___mYKgU","header":"header__header___3v_A5"};